// src/portals/CoachPortal.jsx

import React from 'react';
import SquadDashboard from '../components/SquadDashboard';
import LeadershipHubView from '../components/LeadershipHubView';
import AthletePortal from './AthletePortal';
import { leadershipData } from '../data/content';

const CoachPortal = (props) => {
    const { activeTab, currentUser, handleAiTrigger } = props;

    switch (activeTab) {
        case 'squad-dashboard': 
            return <SquadDashboard currentUser={currentUser} />;
        case 'leadership': 
            return <LeadershipHubView data={leadershipData} onAskAi={handleAiTrigger} />;
        default:
            // If it's not a coach-specific tab, let the Athlete Portal handle it (e.g. Personal Hub)
            return <AthletePortal {...props} />;
    }
};

export default CoachPortal;